import React from 'react'
import type { ProviderProps } from './Context'
import { TemplateProvider } from './Context'
import { Layout } from './Layout'

export const Template = (props: Omit<ProviderProps, 'children'>) => {
  return (
    <TemplateProvider {...props}>
      <Layout />
    </TemplateProvider>
  )
}
